























import { Component, Advisor, Prop, Vue } from "@zoovu/runner-browser-api";
import { ResultsSectionView } from "@zoovu/runner-web-design-base";
import Breadcrumbs from "./breadcrumb.vue";

@Component({
  name: "ResultsSectionView",
  mixins: [ResultsSectionView],
  components: {
    Breadcrumbs
  }
})
export default class ResultsSectionViewExtended extends Vue {
  @Prop()
  private advisor: Advisor;
}
